import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginPageCustomerComponent from "./LoginPageCustomerComponent";

const LoginPageCustomer = () => {
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/');
    }

    return (
        <LoginPageCustomerComponent redirectCustomer = { () => redirect() } />
    );

}

export default LoginPageCustomer;